/** Default visible columns in left-to-right display order (schema order matches). */
export const INVITE_NEW_USER_TABLE_DEFAULT_VISIBLE_KEYS = [
  'name',
  'email_address',
  'create_date',
  'total_buildings',
  'total_units',
  'invite_user',
  'actions',
];

/** Bump when default columns/order change so persisted prefs reset. */
export const INVITE_NEW_USER_TABLE_STORAGE_KEY = 'invite-new-user-list-v1';
